import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../_services';

@Injectable({
  providedIn: 'root'
})
export class PayoutCommerceGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      const customerType = localStorage.getItem('customerType');
      await this.authService.isKashioGrantsAvailable();
      if (this.authService.grantsSubMenuAvailable('PAYOUTS', 'LIST-COMPANIES') && customerType === 'PSP_PAYOUT') {
        return true;
      }
      this.router.navigate(['/loading']);
      return false;
    } catch (error) {
      console.error('Error! while trying to execute Payot commerce guard', error);
      this.router.navigate(['/loading']);
      return false;
    }
  }
}
